import React from 'react';
import styles from './day-glance.module.css';
import CTAButton from "../../../common/v2/CTA-Button/cta-button";
import {ABOUT_PAGE_CONTENT} from "../aboutPageContent";
import Lazy from "../../../common/lazy-scroll/Lazy";

interface Section {
    title: string;
    text: string;
    image: string;
    reverse?: boolean;
}

const sections: Section[] = [
    {
        title: 'Matinée Accueillante',
        text: 'Les enfants sont enveloppés de calme et de réconfort dès leur arrivée, prêts à se lancer dans leurs aventures quotidiennes.',
        image: '/images/about/morning.jpg',
    },
    {
        title: 'Activités Ludiques',
        text: 'Des jeux éducatifs, des activités créatives et du temps en plein air stimulent l\'imagination et la créativité, rythmant la journée de moments joyeux et enrichissants.',
        image: '/images/about/activities.jpg',
        reverse: true,
    },
    {
        title: 'Repas et Sieste',
        text: 'Des repas faits maison, préparés avec amour et soin, offrent une alimentation équilibrée et savoureuse,' +
            ' suivis d’un temps de repos personnalisé pour chaque enfant, favorisant ainsi leur croissance et leur épanouissement.',
        image: '/images/about/lunch-nap.jpg'
    },
];

const DayGlance: React.FC = () => {
    return (
        <>
            <section className={styles.section_container}>
                <h2 className={styles.section_title}>{ABOUT_PAGE_CONTENT.dayGlance.sectionTitle}</h2>
                <p className={styles.intro_paragraph}>
                    {ABOUT_PAGE_CONTENT.dayGlance.paragraph}
                </p>
                {sections.map((section, idx) => (
                    <div
                        key={idx}
                        className={`${styles.section} ${section.reverse ? styles.reverse : ''}`}
                    >
                        <div className={styles.image_container}>
                            {/*<img*/}
                            {/*    src={section.image}*/}
                            {/*    alt="Espace chaleureux de la garderie"*/}
                            {/*    className={styles.image}*/}
                            {/*/>*/}
                            <Lazy SrcImage={section.image}
                                  className={styles.image}
                                  alt={"Espace chaleureux de la garderie"}
                            />
                        </div>
                        <div className={styles.text}>
                            <h3>{section.title}</h3>
                            <p>{section.text}</p>
                        </div>
                    </div>

                ))}
                <CTAButton text={"Voir les programmes"} href={"/Programes"}/>
            </section>
        </>
    )
        ;
};

export default DayGlance;
